/**
 * THE ACCOUNTS THAT ARE THIS COMPANY, WRITTEN ONCE.
 *
 * `sameAs` on the Organization schema is the list of URLs that ARE Stylon
 * elsewhere on the web — what a search engine or an assistant reads to decide
 * which "Stylon" it is looking at. Searching `stylon` put stylon.co at rank 9
 * of 9, behind a Google Play app actually called StylOn in the same business
 * (salon and grooming booking), an app called StylAi that transliterates to
 * the same Arabic word, and several unrelated homonyms. One social URL and a
 * company registration number nobody published is not enough to tell them
 * apart.
 *
 * It used to be written in three places, and the three disagreed:
 *
 *     src/seo/pageMeta.js      instagram.com/stylon.co
 *     public/index.html        instagram.com/stylon.co
 *     Footer.js                instagram.com/stylon.community
 *
 * All three were wrong. The company's Instagram is `stylon.platform`;
 * `stylon.community` is its FACEBOOK page, and someone had pasted the Facebook
 * handle into an Instagram URL. So the schema spent months telling Google that
 * Stylon is an account it does not own.
 *
 * Fetching them could not have caught it: Instagram answers 200 with a generic
 * shell for ANY handle when the caller is not logged in, so a handle that does
 * not exist looks alive. Only the owner could say.
 *
 * Hence one definition. The footer and the schema read it; the static
 * `public/index.html` cannot import a constant, so a test holds it to this
 * list instead. CommonJS, because the browser bundle and the Jest guard share
 * it — the same reason as seo/siteUrl.js.
 *
 * ADDING ONE: put the absolute https URL here and nowhere else, and only when
 * the owner has confirmed the account is theirs. A guessed profile is worse
 * than a missing one — it asserts an identity to every engine that reads it.
 */
const INSTAGRAM_URL = 'https://www.instagram.com/stylon.platform';
const FACEBOOK_URL = 'https://www.facebook.com/stylon.community';
const TIKTOK_URL = 'https://www.tiktok.com/@stylonplatform';

/* Order is not meaningful to schema.org; it is the order they were confirmed.
 * Still missing, and worth asking for: LinkedIn, YouTube, Wikidata. Note the
 * handles differ per network — `stylon.platform` on Instagram,
 * `stylon.community` on Facebook, `stylonplatform` on TikTok — which is
 * exactly why each is written out in full rather than built from one name. */
const SOCIAL_PROFILES = [INSTAGRAM_URL, FACEBOOK_URL, TIKTOK_URL];

module.exports = { INSTAGRAM_URL, FACEBOOK_URL, TIKTOK_URL, SOCIAL_PROFILES };
